/* eslint-disable import/no-unresolved,import/extensions,import/no-duplicates,import/no-named-as-default-member */
import Loadable from 'react-loadable';

import LoadingIndicator from 'components/LoadingIndicator';

export default Loadable({
  loader: () => import('./index'),
  loading: LoadingIndicator,
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Loadable.js